import { AxiosInstance } from "axios";

import { IItem } from "../interfaces/IItem";
import { updateObjectStateUrl, fetchAllWorkflowsUrl, fetchWorkflowStatesUrl } from "../helpers/urlHelper";
import { IObjectWorkflowState } from "../interfaces/mfiles/IObjectWorkflowState";
import { IWorkflowId, IWorkflowState, IWorkflow } from "../interfaces/configuration/IConfiguration";

export const updateObjectStateAsync = async (httpClient: AxiosInstance, item: IItem, newStateId: number): Promise<void> => {
  const url = updateObjectStateUrl(item.objectType, item.objectId);
  const data: IObjectWorkflowState = { StateID: newStateId };
  await httpClient.put(url, data);
};

export const getAllWorkflows = async (httpClient: AxiosInstance): Promise<IWorkflow[]> => {
  const response = await httpClient.get<IWorkflow[]>(fetchAllWorkflowsUrl());
  return response.data;
};

export const getWorkflowStates = async (httpClient: AxiosInstance, workflowId: IWorkflowId): Promise<IWorkflowState[]> => {
  const response = await httpClient.get<IWorkflowState[]>(fetchWorkflowStatesUrl(workflowId));
  return response.data;
};
